import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { LocationType } from 'src/app/domain/enums/location-type.enum';

@Component({
  selector: 'app-finance-table',
  templateUrl: './finance-table.component.html',
  styleUrls: ['./finance-table.component.css']
})
export class FinanceTableComponent {

  @Input() title: string = '';
  @Input() locationType: string = '';
  @Input() data: any[] = [];
  @Input() formDirective!: FormGroupDirective;
  @Input() totalCosts: any;
  @Input() totalDiscounts: any;
  @Output() openCreate = new EventEmitter<{formDirective: FormGroupDirective, type: string}>();
  @Output() openEdit = new EventEmitter<{value: any, type: string}>();
  @Output() delete = new EventEmitter<number>();
  
  locationTypeEnum = LocationType

  onOpenCreate() {
    this.openCreate.emit({formDirective: this.formDirective, type: this.locationType});
  }

  onOpenEdit(row: any) {
    this.openEdit.emit({value: row, type: this.locationType});
  }

  confirmDelete(id: number) {
    this.delete.emit(id);
  }

  calculateTotalPerCurrency(currencyCode: string) {
    let total = 0;

    if (this.data) {
      for (let row of this.data) {
        if (row.currencyCode === currencyCode) {
          total += row.amount;
        }
      }
    }

    return total;
  }
}
